import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'


const LoadContainer     = Loadable({ loader: () => import('layers/heroes/containers/LoadContainer/LoadContainer'), loading })
const ModalContainer    = Loadable({ loader: () => import('layers/heroes/containers/ModalContainer/ModalContainer'), loading })
const PageNavigationContainer = Loadable({ loader: () => import('layers/heroes/containers/PageNavigationContainer/PageNavigationContainer'), loading })
const ListPage          = Loadable({ loader: () => import('layers/heroes/pages/ListPage/ListPage'), loading })
const MyListPage        = Loadable({ loader: () => import('layers/heroes/pages/MyListPage/MyListPage'), loading })
const ModerateListPage  = Loadable({ loader: () => import('layers/heroes/pages/ModerateListPage/ModerateListPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route component={ModalContainer}>
      <Route component={PageNavigationContainer}>
        <Route path={links.root} component={ListPage} />
        <Route path={links.my} component={MyListPage} />
        <Route path={links.moderate} component={ModerateListPage} />

        <Redirect path={`${links.root}/*`} to={links.root} />
      </Route>
    </Route>
  </Route>
)
